import React from "react";
import SingleCollection from "../../../shared-components/SingleCollection/SingleCollection";
import CardV2 from "../../../shared-components/CardV2/CardV2";
import TrendingProfile from "./components/TrendingProfile/TrendingProfile";
import InfoCard from "./components/InfoCard/InfoCard";

import { AnimationFileLoader } from "../../../utilis/animation-loader"; // Adjust the path

// Import Swiper React components
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import "swiper/css";
import {NavLink } from "react-router-dom";

//    <link rel="stylesheet" to="./plugins/nice-select/nice-select.css" />

//Particle Js
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";

function HomeV3() {
  AnimationFileLoader();

  let LiveAuctionHook = useSwiper();

  let TrendingAuctionHook = useSwiper();

  const particlesInit = async (main) => {
    // you can initialize the tsParticles instance (main) here, adding custom shapes or presets 
    // this loads the tsparticles package bundle, it's the easiest method for getting everything ready 
    // starting from v2 you can add only the features you need reducing the bundle size 
    await loadFull(main);
  };
  const particlesLoaded = (container) => {
  };



  return (
    <>
    
      {/* Banner */}

      <div className="banner style--two ov-hidden" data-bg-img="/img/bg/banner-bg3.png">

        <Particles
          init={particlesInit}
          loaded={particlesLoaded}
          options={{
            fullScreen: false,
            fpsLimit: 60,
            particles: {
              number: {
                value: 200,
                density: {
                  enable: true,
                  value_area: 800,
                },
              },
              color: {
                value: "#ffffff",
              },
              shape: {
                type: "circle",
                stroke: {
                  width: 0,
                  color: "#000000",
                },
                polygon: {
                  nb_sides: 5,
                },
                image: {
                  src: "/img/github.svg",
                  width: 100,
                  height: 100,
                },
              },
              opacity: {
                value: 0.5,
                random: false,
                anim: {
                  enable: false,
                  speed: 1,
                  opacity_min: 0.1,
                  sync: false,
                },
              },
              size: {
                value: 3,
                random: true,
                anim: {
                  enable: false,
                  speed: 40,
                  size_min: 0.1,
                  sync: false,
                },
              },
              line_linked: {
                enable: false,
                distance: 150,
                color: "#ffffff",
                opacity: 0.4,
                width: 1,
              },
              move: {
                enable: true,
                speed: 2,
                direction: "none",
                random: false,
                straight: false,
                out_mode: "out",
                bounce: false,
                attract: {
                  enable: false,
                  rotateX: 600,
                  rotateY: 1200,
                },
              },
              interactivity: {
                detect_on: "canvas",
                events: {
                  onhover: {
                    enable: false,
                    mode: "repulse",
                  },
                  onclick: {
                    enable: true,
                    mode: "push",
                  },
                  resize: false,
                },
                modes: {
                  grab: {
                    distance: 400,
                    line_linked: {
                      opacity: 1,
                    },
                  },
                  bubble: {
                    distance: 400,
                    size: 40,
                    duration: 2,
                    opacity: 8,
                    speed: 3,
                  },
                  repulse: {
                    distance: 200,
                    duration: 0.4,
                  },
                  push: {
                    particles_nb: 4,
                  },
                  remove: {
                    particles_nb: 2,
                  },
                },
              },
              retina_detect: true,
            },
          }}
        />

        <div className="container">
          <div className="row">
            <div className="col-lg-1">
              {/* Banner Content */}
              <div className="banner-content text-white mb-5 mb-lg-0">
                <h2 className="stroke-text">Digital</h2>
                <h1>Collection And Sell, NFTs</h1>
                <NavLink to="create.html" className="btn">
                  <img src="/img/icons/discover.svg" alt="" className="svg" />
                  Discover
                </NavLink>
              </div>
              {/* End Banner Content */}
            </div>
            <div className="col-lg-11">
              {/* Banner IMG */}
              <div className="banner-img mb-60 mb-lg-0">
                <img src="/img/media/banner-img3.png" alt="" />
              </div>
              {/* End Banner IMG */}
            </div>
          </div>
        </div>

      </div>
      {/* End Banner */}

      {/* Top Collection */}
      <section className="pt-120 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-8">
              {/* Section Title */}
              <div className="section-title style--two">
                <div className="d-flex flex-wrap align-items-center">
                  <h2 className="text-white">
                    <img
                      src="/img/icons/title-icon1.svg"
                      alt=""
                      className="svg mt-1 me-3"
                    />
                    Top Collections
                  </h2>

                  <select className="select">
                    <option value="24_hour">24 Hours</option>
                    <option value="3_days">3 Days</option>
                    <option value="7_days">7 Days</option>
                  </select>
                </div>
              </div>
              {/* End Section Title */}
            </div>
            <div className="col-lg-4 d-none d-lg-block">
              <div className="d-flex justify-content-lg-end">
                <NavLink to="collection.html" className="btn btn-border btn-sm">
                  <img src="/img/icons/view-all.svg" alt="" className="svg" />{" "}
                  View All
                </NavLink>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="Meka_Verse"
                price="$203,621,269"
                count="01"
              />

              {/* End Collection */}
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="Bored_YachtClub"
                price="$118,321,276"
                count="02"
              />

              {/* End Collection */}
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="Bambooz_lers"
                price="$10,429,103"
                count="03"
              />

              {/* End Collection */}
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="The_Humanoids"
                price="$7,991,156"
                count="04"
              />

              {/* End Collection */}
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="Stacked_Toadz"
                price="$6,700,653"
                count="05"
              />

              {/* End Collection */}
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="Mutant_Cats"
                price="$22,278,069"
                count="06"
              />

              {/* End Collection */}
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="Mutant_YachtClub"
                price="$10,307,676"
                count="07"
              />

              {/* End Collection */}
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="Optics_PeopleS"
                price="$19,359,169"
                count="08"
              />

              {/* End Collection */}
            </div>

            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="Goofy_Oversized"
                price="$203,621,269"
                count="09"
              />

              {/* End Collection */}
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="Cyber_Kongz"
                price="$7,227,956"
                count="10"
              />

              {/* End Collection */}
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="The_DogePound"
                price="$6,609,169"
                count="11"
              />

              {/* End Collection */}
            </div>
            <div className="col-xl-3 col-lg-4 col-sm-6">
              {/* Collection */}
              <SingleCollection
                name="Halloween_Bears"
                price="$4,673,966"
                count="12"
              />

              {/* End Collection */}
            </div>

            <div className="col-12 d-lg-none">
              <div className="d-flex justify-content-center mb-30">
                <NavLink to="collection.html" className="btn btn-border btn-sm">
                  <img src="/img/icons/view-all.svg" alt="" className="svg" />{" "}
                  View All
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* End Top Collection */}

      {/* Live Auction */}
      <section className="pt-120 pb-120 section-bg">
        <div className="container">
          <div className="row">
            <div className="col-sm-8">
              {/* Section Title */}
              <div className="section-title style--two text-white">
                <h2>
                  <img
                    src="/img/icons/title-icon2.svg"
                    alt=""
                    className="svg mt-1 me-3"
                  />
                  Live Auctions
                </h2>
              </div>
              {/* End Section Title */}
            </div>
            <div className="col-sm-4 d-none d-sm-block">
              <div className="swiper-nav">
                <div
                  className="swiper-button swiper-button-prev"
                  onClick={() => {
                    LiveAuctionHook != null
                      ? LiveAuctionHook.slidePrev()
                      : console.log("Null");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M15 18 9 12 15 6" />
                  </svg>
                </div>
                <div
                  className="swiper-button swiper-button-next"
                  onClick={() => {
                    LiveAuctionHook != null
                      ? LiveAuctionHook.slideNext()
                      : console.log("Null");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18 15 12 9 6" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {/* Swiper */}

              <Swiper
                className="swiper live-auction"
                onSwiper={(swiper) => {
                  LiveAuctionHook = swiper;
                }}
                loop={true}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                modules={[Navigation, Pagination]}
                spaceBetween={30}
                slidesPerView={4}
                onSlideChange={() => console.log("slide change")}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                  1400: { slidesPerView: 4 },
                }}
              >
                <SwiperSlide>
                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Colourful Painting"
                    price="0.99 ETH"
                    info="3 to 100"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--two"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Redical Painting"
                    price="1.98 ETH"
                    info="9 to 100"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--two"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Colourful Painting"
                    price="2.09 ETH"
                    info="2 to 220"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--two"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Horrotic Painting"
                    price="1.89 ETH"
                    info="7 to 120"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--two"
                  />
                </SwiperSlide>

                {/* In order to make the infine loop working we have to add double the amount of slides  get the slideperview from swiper hook => params => slidesPerView */}
                <SwiperSlide>
                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Colourful Painting"
                    price="0.99 ETH"
                    info="3 to 100"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--two"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Redical Painting"
                    price="1.98 ETH"
                    info="9 to 100"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--two"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Colourful Painting"
                    price="2.09 ETH"
                    info="2 to 220"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--two"
                  />
                </SwiperSlide>
                <SwiperSlide>
                  <CardV2
                    backImgSrc="/img/product/product10.png"
                    profileImages={[
                      { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                      { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                      { imgSrc: "/img/media/owner3.png", title: "Tom" },
                    ]}
                    statusImgSrc="/img/icons/check2.svg"
                    heading="Horrotic Painting"
                    price="1.89 ETH"
                    info="7 to 120"
                    timeLeft={{ hours: "00", minutes: "00", seconds: "00" }}
                    classList="single-product style--two"
                  />
                </SwiperSlide>
                {/* End */}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      {/* End Live Auction */}

      {/* Feeds */}
      <section className="pt-120 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-xl-4">
              {/* Section Title */}
              <div className="section-title style--two d-flex align-items-center justify-content-between">
                <h2 className="text-white">
                  <img
                    src="/img/icons/fire.png"
                    alt=""
                    className="mt-1 me-3"
                  />
                  Feeds
                </h2>

                <select className="select-rounded mt-1 me-xl-4">
                  <option value="Following">Following</option>
                  <option value="Meka_Verse">Meka_Verse</option>
                  <option value="Bored_YachtClub">Bored_YachtClub</option>
                  <option value="Bambooz_lers">Bambooz_lers</option>
                  <option value="The_Humanoids">The_Humanoids</option>
                  <option value="Stacked_Toadz">Stacked_Toadz</option>
                </select>
              </div>
              {/* End Section Title */}
            </div>
            <div className="col-xl-8 mb-30 mb-xl-0">
              <div className="d-flex align-items-center flex-wrap justify-content-center justify-content-lg-between justify-content-xl-end">
                <div
                  id="filters"
                  className="d-flex flex-wrap justify-content-center justify-content-xl-end"
                >
                  <button className="button is-checked" data-filter="*">
                    All
                  </button>
                  <button className="button" data-filter=":not(.artwork)">
                    Artwork
                  </button>
                  <button className="button" data-filter=":not(.photography)">
                    Photography
                  </button>
                  <button className="button" data-filter=":not(.games)">
                    Games
                  </button>
                  <button className="button" data-filter=":not(.domain)">
                    Domains
                  </button>
                  <button className="button" data-filter=":not(.memes)">
                    Memes
                  </button>
                </div>
                <NavLink
                  to="explore.html"
                  className="btn btn-sm ms-3 d-none d-lg-inline-flex"
                >
                  <img src="/img/icons/view-all.svg" alt="" className="svg" />
                  View All
                </NavLink>
              </div>
            </div>
          </div>
          <div className="grid row justify-content-center">
            <div className="col-xl-3 col-lg-4 col-md-6 element-item artwork memes">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product10.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Colourful Painting"
                price="0.99 ETH"
                info="3 to 100"
                likes="13.6k"
                classList="single-product style--three"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item photography">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product10.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Redical Painting"
                price="1.99 ETH"
                info="9 to 100"
                likes="13.6k"
                classList="single-product style--three"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item games">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product10.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Colourful Painting"
                price="2.09 ETH"
                info="2 to 220"
                likes="13.6k"
                classList="single-product style--three"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item domain">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product10.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Horrotic Painting"
                price="1.89 ETH"
                info="7 to 120"
                likes="13.6k"
                classList="single-product style--three"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item artwork">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product13.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Animal Girl Painting"
                price="4.36 ETH"
                info="5 to 200"
                likes="13.6k"
                classList="single-product style--three"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item photography">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product14.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="The Third Eye"
                price="3.66 ETH"
                info="3 to 320"
                likes="13.6k"
                classList="single-product style--three"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item games memes">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product14.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Glue Painting"
                price="0.99 ETH"
                info="30 to 100"
                likes="13.6k"
                classList="single-product style--three"
              />

              {/* End Single Product */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6 element-item domain">
              {/* Single Product */}

              <CardV2
                backImgSrc="/img/product/product14.png"
                profileImages={[
                  { imgSrc: "/img/media/owner1.png", title: "mr. Jone" },
                  { imgSrc: "/img/media/owner2.png", title: "Laumi" },
                  { imgSrc: "/img/media/owner3.png", title: "Tom" },
                ]}
                statusImgSrc="/img/icons/check2.svg"
                heading="Osean Painting"
                price="1.69 ETH"
                info="1 to 100"
                likes="13.6k"
                classList="single-product style--three"
              />

              {/* End Single Product */}
            </div>
          </div>
          <div className="row">
            <div className="col-12 d-lg-none text-center mb-30">
              <NavLink to="explore.html" className="btn btn-sm ms-3">
                <img src="/img/icons/view-all.svg" alt="" className="svg" />
                View All
              </NavLink>
            </div>
          </div>
        </div>
      </section>
      {/* End Feeds */}

      {/* Trending  */}
      <section className="pt-120 pb-120 section-bg">
        <div className="container">
          <div className="row">
            <div className="col-sm-8">
              {/* Section Title */}
              <div className="section-title style--two">
                <div className="d-flex flex-wrap align-items-center">
                  <h2 className="text-white">
                    <img
                      src="/img/icons/title-icon1.svg"
                      alt=""
                      className="svg mt-1 me-3"
                    />
                    Trending in
                  </h2>

                  <select className="select">
                    <option value="all_cat">all Categories</option>
                    <option value="trading_paint">Trading Paint</option>
                    <option value="art_painting">Art Painting</option>
                    <option value="virtual_paints">Virtual Paints</option>
                    <option value="collectibles">Collectibles</option>
                  </select>
                </div>
              </div>
              {/* End Section Title */}
            </div>
            <div className="col-sm-4 d-none d-sm-block">
              <div className="swiper-nav">
                <div
                  className="swiper-button swiper-button-prev"
                  onClick={() => {
                    TrendingAuctionHook != null
                      ? TrendingAuctionHook.slidePrev()
                      : console.log("Null");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M15 18 9 12 15 6" />
                  </svg>
                </div>
                <div
                  className="swiper-button swiper-button-next"
                  onClick={() => {
                    TrendingAuctionHook != null
                      ? TrendingAuctionHook.slideNext()
                      : console.log("Null");
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18 15 12 9 6" />
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              {/* Swiper */}
              <Swiper
                className="swiper live-auction"

                onSwiper={(swiper) => {
                  TrendingAuctionHook = swiper;
                }}
                loop={true}
                pagination={{
                  clickable: true,
                }}
                navigation={true}
                modules={[Navigation, Pagination]}
                spaceBetween={30}
                slidesPerView={4}
                onSlideChange={() => console.log("slide change")}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  768: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                  1400: { slidesPerView: 4 },
                }}
              >
                <SwiperSlide>
                  <TrendingProfile
                    coverSrc="/img/media/profile-cover1.png"
                    profileSrc="/img/media/profile1.png"
                    statusSrc="/img/icons/check-white.svg"
                    heading="Colourful Painting"
                    authorName="Meka_Verse"
                    description="The revenants are the world’s first Intelligent Collectibles."
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <TrendingProfile
                    coverSrc="/img/media/profile-cover2.png"
                    profileSrc="/img/media/profile2.png"
                    statusSrc="/img/icons/check-white.svg"
                    heading="Redical Painting"
                    authorName="Summy_Scottt"
                    description="The revenants are the world’s first Intelligent Collectibles."
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <TrendingProfile
                    coverSrc="/img/media/profile-cover2.png"
                    profileSrc="/img/media/profile2.png"
                    statusSrc="/img/icons/check-white.svg"
                    heading="Horrotic Painting"
                    authorName="Kwami_Luca"
                    description="The revenants are the world’s first Intelligent Collectibles."
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <TrendingProfile
                    coverSrc="/img/media/profile-cover2.png"
                    profileSrc="/img/media/profile2.png"
                    statusSrc="/img/icons/check-white.svg"
                    heading="Colourful Painting"
                    authorName="Kandi_Logan"
                    description="The revenants are the world’s first Intelligent Collectibles."
                  />
                </SwiperSlide>

                {/* In order to make the infine loop working we have to add double the amount of slides  get the slideperview from swiper hook => params => slidesPerView */}

                <SwiperSlide>
                  <TrendingProfile
                    coverSrc="/img/media/profile-cover1.png"
                    profileSrc="/img/media/profile1.png"
                    statusSrc="/img/icons/check-white.svg"
                    heading="Colourful Painting"
                    authorName="Meka_Verse"
                    description="The revenants are the world’s first Intelligent Collectibles."
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <TrendingProfile
                    coverSrc="/img/media/profile-cover2.png"
                    profileSrc="/img/media/profile2.png"
                    statusSrc="/img/icons/check-white.svg"
                    heading="Redical Painting"
                    authorName="Summy_Scottt"
                    description="The revenants are the world’s first Intelligent Collectibles."
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <TrendingProfile
                    coverSrc="/img/media/profile-cover2.png"
                    profileSrc="/img/media/profile2.png"
                    statusSrc="/img/icons/check-white.svg"
                    heading="Horrotic Painting"
                    authorName="Kwami_Luca"
                    description="The revenants are the world’s first Intelligent Collectibles."
                  />
                </SwiperSlide>

                <SwiperSlide>
                  <TrendingProfile
                    coverSrc="/img/media/profile-cover2.png"
                    profileSrc="/img/media/profile2.png"
                    statusSrc="/img/icons/check-white.svg"
                    heading="Colourful Painting"
                    authorName="Kandi_Logan"
                    description="The revenants are the world’s first Intelligent Collectibles."
                  />
                </SwiperSlide>

                {/*  */}

              </Swiper>
            </div>
          </div>
        </div>
      </section>
      {/* End Trending  */}

      {/* Create & Sell NFTS  */}
      <section className="pt-120 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {/* Section Title */}
              <div className="section-title style--two">
                <div className="d-flex flex-wrap align-items-center">
                  <h2 className="text-white">Create & Sell Your NFTs</h2>
                </div>
              </div>
              {/* End Section Title */}
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-xl-3 col-lg-4 col-md-6">
              {/* Sell NFTs */}
              <InfoCard
                imgSrc="/img/icons/sell1.png"
                heading="Setup Your Wallet"
                info="Once you’ve set up your wallet of choice, connect it to anefty by clicking the wallet icon."
              />
              {/* End Sell NFTs */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6">
              {/* Sell NFTs */}

              <InfoCard
                imgSrc="/img/icons/sell2.png"
                heading="Create Your Collection"
                info="Click my collections and set up your collection. add social link NavLink description and others"
              />

              {/* End Sell NFTs */}
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6">
              {/* Sell NFTs */}

              <InfoCard
                imgSrc="/img/icons/sell3.png"
                heading="Add Our NFTs"
                info="Upload your work likes Image, video, audio or 3D art to anefty by clicking the wallet
                                    icon. "
              />
            </div>
            <div className="col-xl-3 col-lg-4 col-md-6">
              {/* Sell NFTs */}
              <InfoCard
                imgSrc="/img/icons/sell4.png"
                heading="List Them for Sale"
                info="Choose between auction wallet of choice, connect it social link NavLink description and others"
              />
              {/* End Sell NFTs */}
            </div>
          </div>
        </div>
      </section>
      {/* End Create & Sell NFTS  */}

      {/* Footer Wrap */}
      <div className="footer-overlay" data-bg-img="/img/bg/footer-bg.png">
        {/* Newsletter */}
        <section className="newsletter-sec">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="newsletter-content text-white mb-30 mb-lg-0 text-center text-lg-start">
                  <h4>Stay in the Loop</h4>
                  <p>
                    Join our mail list to stay in the loop with our newest
                    feature release, NFTs{" "}
                  </p>
                </div>
              </div>
              <div className="col-lg-6">
                <form
                  action="https://themelooks.us13.list-manage.com/subscribe/post?u=79f0b132ec25ee223bb41835f&id=f4e0e93d1d"
                  className="newslatter-form style--two"
                >
                  <div className="theme-input-group">
                    <input
                      className="form-control"
                      type="email"
                      placeholder="Email here…"
                    />
                    <button type="submit" className="submit-btn btn">
                      <img src="/img/icons/mail.svg" alt="" className="svg" />{" "}
                      Subscribe
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        {/* End Newsletter */}

     
      </div>
      {/* End Footer Wrap */}
    </>
  );
}

export default HomeV3;
